import React from 'react';
import { TaskType, isGenerativeTask } from '@/shared/domain/taskTypes';
const RequiredOutputFormat = <div className='fs-unmask'>Required Output Format</div>;

const schemas = {
    classificationSingle: `{
    "labels": list[str],
    "extra_params": Optional[dict]
}`,
    classificationMulti: `{
    "labels": list[str],
    "extra_params": Optional[dict]
}`,
    ner: `[{
        "label": str,
        "content": str,
        "start_index": int,
        "extra_params": Optional[dict]
    }]`,
    nerWithRelations: `{
    "entities": [
        {
            "label": str,
            "content": str,
            "start_index": int,
        },
    ],
    "relations": [
        {
            "label": str,
            "source_start_index": int,
            "target_start_index": int,
        },
    ],
    "extra_params": Optional[dict]
}`,
    summarization: `{
    "response": str,
    "extra_params": Optional[dict]
}`,
};

const infoText = <span style={{ color: "#898989" }}>The <span style={{ backgroundColor: "#e9eef5", padding: "2px 8px", borderRadius: "4px" }}>extra_params</span> field lets you include additional metadata beyond labels.</span>;

export const getParserSchema = (taskType, isMultilabel) => {
    if (taskType === TaskType.NER_WITH_RELATIONS) {
        return {
            title: RequiredOutputFormat,
            schema: schemas.nerWithRelations,
            info: infoText,
        };
    }

    if (taskType === TaskType.NER) {
        return {
            title: RequiredOutputFormat,
            schema: schemas.ner,
            info: infoText,
        };
    }

    if (taskType === TaskType.classification) {
        return {
            title: RequiredOutputFormat,
            schema: isMultilabel ? schemas.classificationMulti : schemas.classificationSingle,
            info: infoText,
        };
    }

    if (isGenerativeTask(taskType)) {
        return {
            title: RequiredOutputFormat,
            schema: schemas.summarization,
            info: infoText,
        };
    }

    return {
        title: RequiredOutputFormat,
        schema: schemas.classificationSingle,
        info: infoText,
    };
};

